module.exports = __webpack_public_path__ + "img/slider-arrow-next.60fd2b75.svg";